import axios from "@util/axios.js";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const getAvatars = (companiesIds) => {
   const params = companiesIds.map((id) => "companiesIds=" + id + "&");
   return axios({
      method: "GET",
      url: `${hostCloud}/user-avatar/companies?` + params,
      headers: { "Content-Type": "application/json" }
   });
};
